<template>
    <bc-dialog :value="select_address_dialog" :content-class="{ 'd-none': !address_options }" :hide-overlay="!address_options">
        <v-card>
            <v-card-title style="margin-bottom: 0px !important">
                <span class="headline"
                    >{{ $t("lang.select") }} {{ type == "bill_address" ? $t("lang.billing_address_id") : $t("lang.shipping_address_id") }}</span
                >
                <v-spacer></v-spacer>
                <bc-btn-dialog-close @invoke-method="invokeMethod($event)" :dialog-status="select_address_dialog" action="close"></bc-btn-dialog-close>
            </v-card-title>
            <v-card-text class="pa-0" style="margin: 0px !important">
                <vue-perfect-scrollbar style="height: 400px" :settings="settings">
                    <v-list two-line class="auto-lines">
                        <template v-for="(item, index) in address_options">
                            <v-list-tile :key="index" @click="selectAddress(item)">
                                <v-list-tile-content class="pa-3">
                                    <h4 v-if="item.location_label" class="mb-0">
                                        {{ item.location_label }}
                                    </h4>
                                    <h5 class="font-weight-regular mb-0">
                                        {{ item.address1 }}
                                    </h5>
                                    <h5 class="font-weight-regular mb-0" v-if="item.address2">
                                        {{ item.address2 }}
                                    </h5>
                                    <h5 class="font-weight-regular mb-0">{{ item.city }}, {{ item.state }} {{ item.zip }}</h5>
                                </v-list-tile-content>
                                <v-list-tile-action class="pa-3">
                                    <v-chip label disabled color="grey lighten-3" class="ml-0">
                                        <span class="black--text">{{ item.address_type.toUpperCase() }}</span>
                                    </v-chip>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider style="margin: 0px !important"></v-divider>
                        </template>
                    </v-list>
                </vue-perfect-scrollbar>
            </v-card-text>
        </v-card>
    </bc-dialog>
</template>
<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import _ from "lodash";
import { getCurrentAppLayout } from "Helpers/helpers";

export default {
    props: {
        address_id: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            type: null,
            selected: null,
            address_options: null,
            select_address_dialog: false,
            countries: null,
            settings: {
                maxScrollbarLength: 160,
            },
        };
    },
    computed: {},
    mounted: function () {
        if (typeof this.address_options == "undefined") {
            throw new Error('Missing required: "address_options"');
        }
    },
    methods: {
        close() {
            this.select_address_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        selectAddress(item) {
            this.$emit("eventname", item, this.type);
            this.close();
        },
        showAddresses(address_options = null, type = null) {
            this.address_options = !address_options ? null : address_options;
            this.type = !type ? null : type;

            this.$nextTick(() => {
                this.select_address_dialog = true;
            });
        },
    },
};
</script>

<style>
.v-list.auto-lines .v-list__tile {
    height: auto !important;
    padding: 10px 5px 10px 12px !important;
}
</style>
